import { ENV } from '@/constants';

const FooterPage = () => (
  <div className='flex justify-center md:justify-end mt-20'>
    <span className='text-xs text-muted-foreground opacity-50'>
      v {ENV.version}
    </span>
  </div>
);

export default FooterPage;
